/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const CHARGE_TYPE_OPTIONS = [
  { label: 'Not set', value: 'not_set' },
  { label: 'Tip', value: 'tip' },
  { label: 'Gratuity', value: 'gratuity' },
  { label: 'Fee', value: 'fee' },
]

export const CHARGE_TYPE_COLORS = {
  not_set: '#6b7280',
  tip: '#39cd80',
  gratuity: '#61b2fa',
  fee: '#2b4fb9',
}

export const STATUS_LABELS = {
  automatic: 'Automatic',
  pre_filled: 'Pre-filled',
  confirmed: 'Confirmed',
  needs_type: 'Needs type',
}

export const STATUS_COLORS = {
  automatic: '#6b7280',
  pre_filled: '#6b7280',
  confirmed: '#2e7d32',
  needs_type: '#d32f2f',
}

export const chargeTypeLabel = (chargeType) => (
  CHARGE_TYPE_OPTIONS.find((option) => option.value === chargeType)?.label || '-'
)

// Only fees count in net sales.
export const changesNetSales = (fromType, toType) => (fromType === 'fee') !== (toType === 'fee')

// Only tips count in the order's tip; every other charge counts as gratuity.
export const changesTip = (fromType, toType) => (fromType === 'tip') !== (toType === 'tip')

// A change into or out of Fee or Tip recalculates past orders.
export const recalculatesPastOrders = (fromType, toType) => changesNetSales(fromType, toType) || changesTip(fromType, toType)

// What a type change does to the past orders carrying the charge, or else to future orders.
export const typeChangeNote = (fromType, toType, pastOrders) => {
  const notes = []

  if (changesNetSales(fromType, toType)) {
    notes.push(pastOrders
      ? `Their net sales will ${toType === 'fee' ? 'include' : 'no longer include'} this charge.`
      : `Future orders will ${toType === 'fee' ? 'include it in' : 'leave it out of'} net sales.`)
  }
  if (changesTip(fromType, toType)) {
    const countedAs = toType === 'tip' ? 'tip, not gratuity' : 'gratuity, not tip'
    notes.push(pastOrders ? `It will count as their ${countedAs}.` : `Future orders will count it as ${countedAs}.`)
  }

  return notes.join(' ')
}

// "1,000+" when the backend stopped counting at its cap.
export const formatOrdersCount = ({ orders_count: ordersCount = 0, capped = false } = {}) => (
  `${Number(ordersCount).toLocaleString('en-US')}${capped ? '+' : ''}`
)

export const hasPastOrders = (count) => Boolean(count?.orders_count || count?.capped)
